import "./WedgeWireScreenSelectionGuide.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import SelectionHero from "./sections/SelectionHero";
import WedgeGuide from "./sections/WedgeGuide";
import RelatedArticles from "./sections/RelatedArticles";
import QuoteCTA from "./sections/QuoteCTA";
import Footer from "@/reusable_sections/Footer";
export default function WedgeWireScreenSelectionGuidePage() {
  return <div>
      <Header />
      <PageBreadcrumb page="WedgeWireScreenSelectionGuide" />
      <SelectionHero />
      <WedgeGuide />
      <RelatedArticles />
      <QuoteCTA />
      <Footer />
    </div>;
}